<nav>
  <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
    <ng-container *ngIf="!last">
      <span class="breadcrumb">{{ breadcrumb.label }}</span>
    </ng-container>
    <ng-container *ngIf="!last">
      <span class="breadcrumb-icon">&gt;</span>
    </ng-container>
    <ng-container *ngIf="last">
      <span
        class="breadcrumb-active"
        [matTooltip]="breadcrumb.fullLabel || breadcrumb.label"
        [matTooltipDisabled]="!breadcrumb.fullLabel || breadcrumb.label.length <= 30"
        matTooltipPosition="above">
        {{ breadcrumb.label }}
      </span>
    </ng-container>
  </ng-container>
</nav>
